import { render, staticRenderFns } from "./CardBody.vue?vue&type=template&id=680207aa&scoped=true&"
import script from "./CardBody.vue?vue&type=script&lang=js&"
export * from "./CardBody.vue?vue&type=script&lang=js&"
import style0 from "./CardBody.vue?vue&type=style&index=0&id=680207aa&prod&lang=scss&scoped=true&"
import style1 from "./CardBody.vue?vue&type=style&index=1&id=680207aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680207aa",
  null
  
)

export default component.exports